import {FieldKind} from "./object-reflection";
import {TableColumnConfig} from "../model/api/table-column-config";

export class TableColumnUtils {

  static buildColumn<T>(
    field: string,
    type: FieldKind,
    options?: {
      mapId?: (record: T) => string;
      icon?: (record: T) => string;
      filterConfig?: any;
    }
  ): TableColumnConfig {

    const column: TableColumnConfig = {
      field,
      label: field as string,
      showToolTip: true,
      width: this.defaultWidth(type),
      type: this.defaultType(type),
      format: this.defaultFormat(type),
      mapId: options?.mapId,
      icon: options?.icon
    };

    if (options?.filterConfig) {
      column.filterConfig = options.filterConfig;
    }

    return column;
  }

  // ---------- defaults ----------

  static defaultWidth(type: FieldKind): number {
    switch (type) {
      case 'number':
        return 90;
      case 'boolean':
        return 80;
      case 'date':
      case 'datetime':
        return 140;
      case 'enum':
        return 120;
      default:
        return 100;
    }
  }

  static defaultType(type: FieldKind): string | undefined {
    switch (type) {
      case 'number':
        return 'NUMERIC';
      case 'date':
        return 'DATE';
      case 'datetime':
        return 'DATETIME';
      default:
        return undefined;
    }
  }

  static defaultFormat(type: FieldKind): string | undefined {
    switch (type) {
      case 'number':
        return '1.0-7';
      case 'date':
        return 'dd/MM/yyyy';
      case 'datetime':
        return 'dd/MM/yyyy HH:mm:ss';
      default:
        return undefined;
    }
  }

  static booleanIcon<T>(field: keyof T): (record: T) => string {
    return (record: any) =>
      'fas fa-solid fa-' + (record && record[field] ? 'square-check' : 'square');
  }

  static booleanMapId<T>(): (record: T) => string {
    return () => '';
  }
}
